import { useEffect, useRef, useState } from "react";
import { Form, FormControl, FormGroup } from "react-bootstrap";
import { Axios } from "../../../Api/axios";
import LoadingSubmit from "../../../Components/Loading/Loading";
import { useNavigate } from "react-router-dom";
import DashDialog from "../../../Components/Dashboard/DashDialog";

const ADD_AD = "/admin/add_ad";

export default function AddAds() {
  const [advertiserName, setAdvertiserName] = useState("");
  const [description,    setDescription]    = useState("");
  const [location,       setLocation]       = useState("");
  const [phone,          setPhone]          = useState("");
  const [photo,          setPhoto]          = useState(null);
  const [loading,        setLoading]        = useState(false);

  const focus = useRef(null);
  const nav   = useNavigate();

  useEffect(() => { focus.current?.focus(); }, []);

  async function handleSubmit() {
    if (!advertiserName) return;
    setLoading(true);
    const formData = new FormData();
    formData.append("name",        advertiserName);
    formData.append("description", description);
    formData.append("location",    location);
    formData.append("phone",       phone);
    if (photo) formData.append("image", photo);
    try {
      await Axios.post(ADD_AD, formData);
      nav("/dashboard/T_Ads");
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }

  const isValid = advertiserName.length >= 2;

  return (
    <>
      {loading && <LoadingSubmit />}
      <DashDialog
        title="إضافة إعلان جديد"
        onSubmit={handleSubmit}
        submitDisabled={!isValid || loading}
        submitLabel={loading ? "جاري الحفظ..." : "حفظ الإعلان"}
      >
        <Form.Group className="mb-4" controlId="advertiserName">
          <Form.Label>اسم الجهة المعلِنة</Form.Label>
          <Form.Control
            ref={focus}
            value={advertiserName}
            required
            onChange={(e) => setAdvertiserName(e.target.value)}
            type="text"
            placeholder="اسم الجهة المعلنة..."
          />
        </Form.Group>

        <Form.Group className="mb-4" controlId="description">
          <Form.Label>الوصف</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="وصف الإعلان..."
          />
        </Form.Group>

        <Form.Group className="mb-4" controlId="location">
          <Form.Label>الموقع (العنوان)</Form.Label>
          <Form.Control
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            type="text"
            placeholder="العنوان..."
          />
        </Form.Group>

        <Form.Group className="mb-4" controlId="phone">
          <Form.Label>رقم الهاتف</Form.Label>
          <Form.Control
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            type="tel"
            placeholder="رقم الهاتف..."
          />
        </Form.Group>

        <FormGroup className="mb-2" controlId="photo">
          <Form.Label>صورة الإعلان</Form.Label>
          <FormControl
            onChange={(e) => setPhoto(e.target.files[0])}
            type="file"
            accept="image/*"
          />
        </FormGroup>
      </DashDialog>
    </>
  );
}
